import { Box } from '@mui/system';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Content from '../Content';
import Header from '../Header';
import Sidebar from '../Sidebar';

const Dashboard: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen((prevState) => !prevState);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Header open={isDrawerOpen} onToggle={toggleDrawer} />
      <Sidebar onToggle={toggleDrawer} open={isDrawerOpen} />
      <Content>
        <Outlet />
      </Content>
    </Box>
  );
};

export default Dashboard;
